// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TomSelectController from "./tom_select_controller.js"
application.register("tom-select", TomSelectController)

import MobileMenuController from "./mobile_menu_controller.js"
application.register("mobile-menu", MobileMenuController)

import SearchController from "./search_controller.js"
application.register("search", SearchController)

import SwiperController from "./swiper_controller.js"
application.register("swiper", SwiperController)

import FancyboxController from "./fancybox_controller.js"
application.register("fancybox", FancyboxController)

import LoadMoreController from "./load_more_controller.js"
application.register("load-more", LoadMoreController)

import ScrollButtonsController from "./scroll_buttons_controller.js"
application.register("scroll-buttons", ScrollButtonsController)

import SortSyncController from "./sort_sync_controller.js"
application.register("sort-sync", SortSyncController)
